import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { LayoutModule } from "../../theme/layouts/layout.module";
import { FormsModule } from "@angular/forms";
import { appService } from "../../../app/_services/app.service";
import { CommonService } from "../../../app/_services/common.service";
import { NetworkComponent } from "../network/network.component";
import { DatePipe } from "@angular/common";
import { SharedComponentModule } from "../../shared/shared.module";
import { SharedModule } from "../../freightconfirmation/app.sharemodule";
import { NtwCardComponent } from "../ntw-card/ntw-card.component";
import { RatingModule } from "ngx-bootstrap";
import { DocumentsharedModule } from "../../../app/documentshared/documentshared.module";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule, } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        LayoutModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        SharedModule,
        SharedComponentModule,
        RatingModule,
        DocumentsharedModule,
    ],
    exports: [NetworkComponent],
    declarations: [NetworkComponent, NtwCardComponent],

    providers: [appService, CommonService, DatePipe, TranslateConfigService],
})
export class Network_SharedModule { }
